var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighstreet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1584 1584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 376.09,
    x2: 376.09,
    y2: 1581.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#06e9fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#16cffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#30a6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#546dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#694bfa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 939.49,
    y1: 787.58,
    x2: 939.49,
    y2: 1584,
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)"
    },
    d: "M752.18 787.58V395.26H377.56V0H0v1581.05h377.56V787.58h374.62z",
    transform: "translate(228.6)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    d: "M752.18 787.58h374.61V1584H752.18z",
    transform: "translate(228.6)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighstreet);
export default __webpack_public_path__ + "static/media/highstreet.9493fd388b90f066a43d07ccf1076004.svg";
export { ForwardRef as ReactComponent };